import VueRouter from 'vue-router'
import { Forbidden, Login, NotFound, Welcome, Search, GeneralPrinciple } from './components'
import { Register, ForgotPassword, RegisterAnomynous } from './components/auth'
import { Profile, AccountVerify } from './components/profile'
import { DailyChallenge, DailyBonus } from './components/reward'
import { Inbox } from './components/inbox'
import { FAQIndex } from './components/faq'
import { LeaderBoard } from './components/leaderboard'
import { ExchangeGift, ExchangeHistory, BuySticker, ExchangeCollection } from './components/exchange_gift'
import { ParentCertificate, ParentFeedback, ParentReport, ParentAccount, ParentUpgradeAccount, ParentConnectHome, ParentConnect, ParentProfile } from './components/parent'
import { UnitList, LessonDetail, LessonVocabulary, LessonLecture, LessonPractice, IeltsDetail, IeltsList, PreDetail, PreList, ExtensionDetail } from './components/unit'
import { Tutoring } from './components/toturing'
import { LiveClass } from './components/liveclass'
import { Assigment, AssigmentDetail } from './components/assignment'
import { FinalTest } from './components/final_test'
import { PlacementTest } from './components/placement_test'
import { GradeBook } from './components/gradebook'
import {Simulation} from './components/simulation'
import { PaymentDetail, UpgradeAccount, UpgradeFeature } from './components/payment'
import { Ebook, EbookHome } from './components/ebook'
import { Policy } from './components/policy'


import { store } from './store'
import Achievement from "./components/achievement/Achievement";
import Webview from './components/ai_tutor/Webview.vue'

const router = new VueRouter({
    mode: 'history',
    routes: [
        { path: '/', name: 'home', component: Welcome, meta: { requiresAuth: true } },
        { path: '/general-principle', alias: '/privacy-policy', name: 'general_principle', component: GeneralPrinciple, meta: { layout: 'empty-layout', title: 'Terms & Policies' } },

        { path: '/404', name: 'not_found', component: NotFound },
        { path: '/403', name: 'forbidden', component: Forbidden },

        { path: '/apps', name: 'apps', meta: { layout: 'landing-page-layout' } },
        { path: '/lisa', name: 'lisa', meta: { layout: 'landing-page-lisa' } },
        { path: '/login', name: 'login', component: Login, meta: { layout: 'auth-layout' } },
        { path: '/register', name: 'register', component: Register, meta: { layout: 'auth-layout' } },
        // { path: '/register-anomynous', name: 'register_anomynous', component: RegisterAnomynous, meta: { layout: 'auth-layout' } },
        { path: '/forgot-password', name: 'forgot_password', component: ForgotPassword, meta: { layout: 'auth-layout' } },

        { path: '/connect-account-home', name: 'parent_connect_home', component: ParentConnectHome, meta: { layout: 'parent-layout' } },
        { path: '/connect-account', name: 'parent_connect', component: ParentConnect, meta: { layout: 'parent-layout' } },
        { path: '/profile-parent', name: 'parent_profile', component: ParentProfile },

        { path: '/search', name: 'search', component: Search },
        { path: '/policy', name: 'policy', component: Policy , meta: { layout: 'empty-layout-1' } },


        { path: '/profile', name: 'profile', component: Profile },
        { path: '/daily-challenge', name: 'daily_challenge', component: DailyChallenge },
        { path: '/daily-bonus', name: 'daily_bonus', component: DailyBonus },
        { path: '/inbox', name: 'inbox', component: Inbox },
        { path: '/exchange-gift', name: 'exchange_gift', component: ExchangeGift },
        { path: '/exchange-history', name: 'exchange_history', component: ExchangeHistory },
        { path: '/exchange-collection', name: 'exchange_collection', component: ExchangeCollection },
        { path: '/buy-sticker', name: 'buy_sticker', component: BuySticker },
        { path: '/leaderboard', name: 'leaderboard', component: LeaderBoard },
        { path: '/unit/:subject_id/:unit_id/:page', name: 'unit', component: UnitList },
        { path: '/ielt/:subject_id/:unit_id/:page', name: 'ielt', component: IeltsList },
        { path: '/ielts-item/:subject_id-:unit_id-:lesson_id', name: 'ielts_detail', component: IeltsDetail },
        { path: '/pre/:subject_id/:unit_id/:page', name: 'pre', component: PreList },
        { path: '/pre-item/:subject_id-:unit_id-:lesson_id', name: 'pre_detail', component: PreDetail },
        { path: '/extension-item/:subject_id-:unit_id-:lesson_id', name: 'extension_detail', component: ExtensionDetail },
        { path: '/mission', name: 'achievement', component: Achievement },
        { path: '/lesson/:subject_id-:unit_id-:lesson_id', name: 'lesson_detail', component: LessonDetail },
        { path: '/lesson/vocabulary/:item_id', name: 'lesson_vocabulary', component: LessonVocabulary },
        { path: '/lesson/lecture/:item_id', name: 'lesson_lecture', component: LessonLecture },
        { path: '/lesson/practice/:item_id', name: 'lesson_practice', component: LessonPractice },
        { path: '/parent/report', name: 'parent_report', component: ParentReport },
        { path: '/parent/feedback', name: 'parent_feedback', component: ParentFeedback },
        { path: '/parent/account', name: 'parent_account', component: ParentAccount },
        // { path: '/parent/upgrade-account', name: 'parent_upgrade_account', component: ParentUpgradeAccount },
        { path: '/parent/certificate', name: 'parent_certificate', component: ParentCertificate },
        { path: '/upgrade-account', name: 'upgrade_account', component: UpgradeAccount },
        { path: '/upgrade-feature', name: 'upgrade_feature', component: UpgradeFeature },
        { path: '/tutoring', name: 'tutoring', component: Tutoring },
        { path: '/live-class', name: 'liveclass', component: LiveClass },
        { path: '/lesson/:lesson_id/assignment', name: 'assignment', component: Assigment },
        { path: '/lesson/:lesson_id/assignment/:assignment_id', name: 'assignment_detail', component: AssigmentDetail },
        { path: '/payment/detail', name: 'payment_detail', component: PaymentDetail},
        { path: '/final-test/:item_id/:subject_id', name: 'final_test', component: FinalTest },
        // { path: '/payment/detail', name: 'payment_detail', component: PaymentDetail, meta: { layout: 'payment-layout' } },
        { path: '/faq', name: 'faq', component: FAQIndex, meta: { layout: 'faq-layout' } },
        { path: '/parent/grade-book', name: 'grade_book', component: GradeBook },

        { path: '/placement-test/:item_id', name: 'placement_test', component: PlacementTest },

        { path: '/ebook/:unit_id', name: 'ebook', component: Ebook, meta: { layout: 'empty-layout' } },
        { path: '/ebook-home', name: 'ebook_home', component: EbookHome, meta: { layout: 'empty-layout' } },

        { path: '/simulation', name: 'simulation', component: Simulation },

        { path: '/account-verify-:tab', name: 'account_verify', component: AccountVerify, meta: { title: 'Xác thực thông tin tài khoản' } },

        { path: '/account-verify-:tab', name: 'account_verify', component: AccountVerify, meta: { title: 'Xác thực thông tin tài khoản' } },
        { path: '/ai-tutor', name: 'ai_tutor', component: Webview, meta: { layout: 'empty-layout' } },

        { path: '*', component: { default: NotFound, helper: NotFound }, meta: { layout: 'error-layout' } }
    ],
    scrollBehavior(to, from, savedPosition) {
        return {
            x: 0,
            y: 0,
        };
    }
});

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (store.getters.isLoggedIn) {
            //store.dispatch("SET_USER_INFO");

            store.commit('setLoading', true);

            next();

            return
        }else{
            next({ name: 'login' });
        }

        console.log('Auth from route')

        //next('/register-anomynous')
    }

    //store.commit("setLoading", true);

    if (to.name) {
        // Start the route progress bar.
    }

    next()
});

router.afterEach((to, from) => {
    store.commit('setLoading', false);

    /*const public_pages = ['login'];

    if (public_pages.indexOf(to.name) > -1) {
        if (typeof grecaptcha.reset == 'function') {
            grecaptcha.reset();
        }
    }*/
});

export default router;